import moment from "moment";
import { Field, useForm, useFormState } from "react-final-form";
import { DatePicker } from "@pickit/pickit-components";
import { Input } from "component/inputs/Input";
import { DATE_FORMATS } from "utils/constants";
import { InvoiceDataMXProps } from "./types";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const InvoiceDataMX = ({
  isFormEnabled,
  minDate,
  testId,
}: InvoiceDataMXProps) => {
  const { t } = useTranslation();
  const form = useForm();
  const formState = useFormState();
  const [prevInvoiceNumber, setPrevInvoiceNumber] = useState("");

  useEffect(() => {
    setPrevInvoiceNumber(formState.values.invoiceNumber);
  }, [formState.values.invoiceNumber]);

  return (
    <>
      <Field
        type="text"
        name="emisionDate"
        disabled={!isFormEnabled}
        className="Admin-Pickers-input"
        placeholder={t("invoice:dateOfIssuePlaceholder")}
        label={t("invoice:dateOfIssueLabel")}
        language="es"
        outputFormat="DD/MM/YY"
        testId={`${testId}-field-date-issue`}
      >
        {(props: any) => (
          <div>
            <DatePicker
              singleSelection
              outputFormat={DATE_FORMATS.shortDate}
              minDate={minDate}
              maxDate={moment()}
              {...props}
            />
          </div>
        )}
      </Field>

      <div className="invoice-type-mx">
        <Field
          label={t("invoice:voucherTypeLabel")}
          disabled
          type="text"
          placeholder={t("invoice:voucherTypePlaceholder")}
          name="invoiceType.name"
          className="Admin-Pickers-input"
          component={Input}
          testId={`${testId}-field-voucher-type`}
        ></Field>
      </div>
      <Field
        disabled={!isFormEnabled}
        type="text"
        name="invoiceNumber"
        label={t("invoice:invoiceNumberLabel")}
        component={Input}
        className="Admin-Pickers-input"
        placeholder={t("invoice:invoiceNumberPlaceholder")}
        maxLength={36}
        onChange={
          prevInvoiceNumber?.slice(-1) !== "-" && form.mutators.setMXInvoice
        }
        testId={`${testId}-field-invoice-number`}
      >
        {(props: any) => <Input {...props} />}
      </Field>
    </>
  );
};

export default InvoiceDataMX;
